import "@/App.css";
import "@/styles/editorial.css";
import "@/styles/financing.css";
import "@/styles/news.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import AutoBasicCare from "@/pages/AutoBasicCare";
import FAQ from "@/pages/FAQ";
import Tires from "@/pages/Tires";
import Financing from "@/pages/Financing";
import Specials from "@/pages/Specials";
import News from "@/pages/News";
import Article from "@/pages/Article";
import ChatWidget from "@/components/ChatWidget";
import FinancingBanner from "@/components/FinancingBanner";
import SmoothScroll from "@/components/motion/SmoothScroll";
import ScrollManager from "@/components/motion/ScrollManager";

function RouteBodyClass() {
  const location = useLocation();
  useEffect(() => {
    const map = { "/": "home", "/faq": "faq", "/tires": "tires", "/financing": "financing", "/specials": "specials", "/news": "news" };
    const cls = "route-" + (map[location.pathname] || (location.pathname.startsWith("/news/") ? "news" : "other"));
    document.body.classList.forEach((c) => {
      if (c.startsWith("route-")) document.body.classList.remove(c);
    });
    document.body.classList.add(cls);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
      <RouteBodyClass />
      <ScrollManager />
      <Routes>
        <Route path="/" element={<AutoBasicCare />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/tires" element={<Tires />} />
        <Route path="/financing" element={<Financing />} />
        <Route path="/specials" element={<Specials />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:slug" element={<Article />} />
      </Routes>
      {/* Desktop sticky right-rail — visible ≥1024px, hidden on /financing (via body.route-financing CSS) */}
      <FinancingBanner variant="sidebar" />
      <ChatWidget />
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
